export default function isStandaloneMode() {
  return (
    typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    (('standalone' in navigator && (navigator as any).standalone) ||
      window.matchMedia('(display-mode: standalone)').matches)
  );
}
